module.exports = __webpack_public_path__ + "static/media/terrace-4.f3229253.jpg";